import angular from 'angular';

angular
  .module('cxSettings')
  .controller('SettingMenuCtrl', [
    '$scope',
    'checkFeature',
    'dataCache',
    'appUrls',
    '$window',
    settingMenuCtrl,
  ]);

function settingMenuCtrl($scope, checkFeature, dataCache, appUrls, $window) {
  $scope.hasEid = checkFeature('Eid');
  $scope.connectWebUrl = appUrls.connect;
  dataCache.ready().then(function() {
    var company = dataCache.getArray('defaultcompany');
    $scope.connectWebUrl = `${appUrls.connect}?companyId=${company.id}`;
  });
  $scope.openConnect = function() {
    $window.open($scope.connectWebUrl, '_blank');
  };
}
